
    import {Options, Inject, Prop, Watch, Vue} from 'vue-property-decorator';
    import {DI} from '@/brief-hub/config/DependencyInjection';
    import {FreelancerProfileService} from '@/brief-hub/deposit/freelancer/FreelancerProfileService';
    import debounce from 'lodash/debounce';
    import {FreelancerCategoryResource} from '@/common/api/api-raw-types';

    @Options({emits: ['load', 'select']})
    export default class CategoriesSuggestion extends Vue {
        @Inject({from: DI.freelancerProfileService})
        freelancerProfileService!: FreelancerProfileService;

        @Prop({type: String, default: ''})
        value!: string;

        @Prop({type: Number, default: null})
        visibleResult?: number | null;

        @Prop({type: String})
        selectedCategory?: string | null;

        @Prop({type: Array, required: true})
        categories!: FreelancerCategoryResource[];

        private loading = true;
        private debounceSearch = debounce(this.search, 300);

        @Watch('value', {immediate: true})
        refreshPrediction(): void {
            this.loading = true;
            this.debounceSearch();
        }

        async search(): Promise<void> {
            const [categoryPredictions, error] = await this.freelancerProfileService.retrieveCategoryPrediction(this.value);
            if (!error && categoryPredictions) {
                if (this.visibleResult) {
                    this.$emit('load', categoryPredictions.slice(0, this.visibleResult));
                } else {
                    this.$emit('load', categoryPredictions);
                }
            }
            this.loading = false;
        }

        handleSelectCategory(category: FreelancerCategoryResource) {
            this.$emit('select', category);
        }
    }
